import React from 'react'
import { observer, inject } from 'mobx-react'
import { Button } from 'hljd'

export default inject('certificationStore')(
  observer(({ certificationStore: { addCertification } }) => (
    <Button type="primary" onClick={addCertification}>
      +新增品牌
    </Button>
  ))
)
